<template>
  <v-container grid-list-xs>
    <v-container>
      <v-card>
        <v-card-title>Roles</v-card-title>
        <v-card-text>
          <v-row>
            <v-col></v-col>
            <v-btn color="primary" small @click="dialogo=true">Nuevo rol</v-btn>
          </v-row>
          <v-row>
            <v-col>
              <v-data-table :headers="headers" :items="listaRol" class="elevation-1" :loading="loading">
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon small class="mr-2" @click="editarRol(item)">mdi-pencil</v-icon>
                  <v-icon small @click="eliminarRol(item.rolId)">mdi-delete</v-icon>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="dialogo" persistent max-width="75%">
      <v-card>
        <v-card-title>Rol:</v-card-title>
        <v-card-text>
          <v-row>
            <!-- form: rolId -->
            <v-col md="4">
              <v-text-field
                prepend-icon="mdi-clipboard-list"
                label="Rol ID"
                v-model="rol.rolid"
                disabled
              ></v-text-field>
            </v-col>
            <!-- form: nombre -->
            <v-col md="4">
              <v-text-field
                prepend-icon="mdi-clipboard-list"
                label="Nombre"
                v-model="rol.nombre"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-title>Menu:</v-card-title>
        <v-card-text>
          <v-row>
            <!-- form: rolmenu -->
            <v-col>
              <v-list>
                <v-list-item-group v-model="rol.rolMenu" multiple active-class="blue--text">
                  <template
                    v-for="(item, index) in tablalistadomenu.filter(x => x.menupadreId == 0)"
                  >
                    <v-list-item :key="item.orden" :value="item.menuId">
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                          <v-checkbox :input-value="active" color="primary"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title v-text="item.nombre"></v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                    <v-divider v-if="index + 1 < tablalistadomenu.length" :key="index"></v-divider>
                    <template
                      v-for="(item, index) in tablalistadomenu.filter(x => x.menupadreId == item.menuId)"
                    >
                      <v-list-item :key="item.orden" :value="item.menuId" class="pl-10">
                        <template v-slot:default="{ active }">
                            <v-list-item-action>
                              <v-checkbox :input-value="active" color="primary"></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content>
                            <v-list-item-title v-text="item.nombre"></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-list-item>

                      <v-divider v-if="index + 1 < tablalistadomenu.length" :key="index"></v-divider>
                    </template>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
        {{rol}}
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="limpiarForm">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="guardarCambiosRol">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Rolservice from "../../services/Rol.service";
import Menuservice from "../../services/Menu.service";
import RolMenuservice from "../../services/RolMenu.service";
export default {
  data() {
    return {
      rol: {
        rolid: null,
        nombre: "",
        rolMenu: [],
      },
      headers: [
        { text: "Id", value: "rolId" },
        { text: "Nombre", value: "nombre" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      loading: false,
      listaRol: [],
      dialogo: false,
      tablalistadomenu: [],
    };
  },
  methods: {
    cargarTablaRol() {
      this.loading = true;
      Rolservice.ObtenerTodo().then((res) => {
        this.listaRol = res.data;
        this.loading = false;
      });
    },
    cargarTablaMenu() {
      Menuservice.ObtenerTodo().then((res) => {
        this.tablalistadomenu = res.data;
      });
    },
    limpiarForm() {
      this.rol = {
        rolid: null,
        nombre: "",
        rolMenu: [],
      };
      this.dialogo = false;
    },
    editarRol(item) {
      this.rol = {
        rolid: item.rolId,
        nombre: item.nombre,
        rolMenu: item.rolMenu,
      };
      this.dialogo = true;
    },
    async eliminarRol(rolid) {
      var resp = await confirm("¿Desea eliminar el rol?");
      if (resp) {
          Rolservice.Eliminar(rolid).then((res) => {
            this.cargarTablaRol();
          });
      }
    },
    async guardarCambiosRol() {
      var resp = await confirm("¿Desea guardar el rol?");
      if (resp) {
        if (this.rol.rolid != null) {
          Rolservice.Editar(this.rol).then((res) => {
            this.limpiarForm();
            this.cargarTablaRol();
          });
        } else {
          Rolservice.Insertar(this.rol).then((res) => {
            this.limpiarForm();
            this.cargarTablaRol();
          });
        }
      }
    },
  },
  mounted() {
    this.cargarTablaRol();
    this.cargarTablaMenu();
  },
};
</script>

<style>
</style>